export const FULL_CIRCLE = 360;
export const HALF_CIRCLE = 180;
export const THREE_HALF_CIRCLE = 540;

// Map zoom step (−2..+2) to a scale multiplier for the change_perspective tool and preview
export const ZOOM_STEP_TO_MULTIPLIER: Record<number, number> = {
  [-2]: 0.55,
  [-1]: 0.8,
  0: 1.0,
  1: 1.25,
  2: 1.6,
};
